import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { NewsletterPopup } from './NewsletterPopup';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export function Layout() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenPopup');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('hasSeenPopup', 'true');
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <Outlet />
      </main>
      <div className="h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600 opacity-70" />
      <Footer />

      {showPopup && <NewsletterPopup />}
    </>
  );
}
